import ptBrTranslations from "./pt-br";
import enUsTranslations from "./en-us";
import esTranslations from "./es";

const translations = {
  "pt-BR": ptBrTranslations,
  "en-US": enUsTranslations,
  "es": esTranslations,
};

export default translations;